import React from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  IconButton,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { SIMULATION_SETUP_PATH } from '../constants/clientRoutes';

const PageHeader = ({
  title,
  subtitle,
  breadcrumbs = [],
  showBackButton = false,
  backPath = null,
  actions = null,
  sx = {},
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{ mb: 4, ...sx }}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link 
            to={SIMULATION_SETUP_PATH} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              textDecoration: 'none', 
              color: 'inherit' 
            }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          {breadcrumbs.map((crumb, index) => (
            crumb.path ? (
              <Link 
                key={index} 
                to={crumb.path}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {crumb.label}
              </Link>
            ) : (
              <Typography key={index} color="text.primary">
                {crumb.label}
              </Typography>
            )
          ))}
        </Breadcrumbs>
      )}

      <Box sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 3,
        flexWrap: { xs: 'wrap', md: 'nowrap' },
      }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', flex: 1, minWidth: 0 }}>
          {showBackButton && (
            <IconButton
              onClick={handleBack}
              sx={{ mr: 2, mt: 0.25 }}
              color="primary"
              aria-label="Go back"
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <Box>
            <Typography variant="h4" component="h1" gutterBottom={!!subtitle}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body1" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>

        {actions && (
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;